import { render, staticRenderFns } from "./MultiviewPanel.vue?vue&type=template&id=6e0b8fac"
import script from "./MultiviewPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiviewPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports